import InputWithContainer, { Input } from './Input';
import Message from './components/Message';

export { Input, Message as InputMessage };
export default InputWithContainer;
